module.exports = __webpack_public_path__ + "guide-service01.1addd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-service01.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-service01.svg
// module chunks = main